/** Tipos da comissão do representante */
export interface RepresentanteTipoComissao {
    id: number;
    nome: string;
}

export const representanteComissaoCliente: RepresentanteTipoComissao = {id: 1, nome: 'Cliente'};
export const representanteComissaoItem: RepresentanteTipoComissao = {id: 2, nome: 'Item'};
export const representanteComissaoPedido: RepresentanteTipoComissao = {id: 3, nome: 'Pedido'};

export const representanteTiposComissao: RepresentanteTipoComissao[] = [
    representanteComissaoCliente,
    representanteComissaoItem,
    representanteComissaoPedido
];

/** Verifica se o tipo de comissão do representante é por cliente */
export function isTipoComissaoRepresentantePorCliente(tipo: number): boolean {
    return tipo === representanteComissaoCliente.id;
}

/** Verifica se o tipo de comissão do representante é por item */
export function isTipoComissaoRepresentantePorItem(tipo: number): boolean {
    return tipo === representanteComissaoItem.id;
}

/** Verifica se o tipo de comissão do representante é por pedido */
export function isTipoComissaoRepresentantePorPedido(tipo: number): boolean {
    return tipo === representanteComissaoPedido.id;
}
